"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppLayoutTop = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../../utils");

var _composeStencilComponent = require("../../utils/composeStencilComponent");

var _View = _interopRequireDefault(require("../View"));

var _core = require("@emotion/core");

var _excluded = ["children"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var AppLayoutTopBase = function AppLayoutTopBase(_ref) {
  var children = _ref.children,
      viewProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  (0, _react.useEffect)(function () {
    if ((0, _utils.envIsProduction)()) return;

    var childrenNodes = _react.default.Children.toArray(children);

    var warnings = [];

    if (childrenNodes.length > 0) {
      if (childrenNodes.length > 1) {
        warnings.push("Currently, <AppLayoutTop> contains single component only.");
      }

      var childComponentType = childrenNodes[0].type;

      if (typeof childComponentType !== 'string' && (childComponentType === null || childComponentType === void 0 ? void 0 : childComponentType.displayName) !== 'MessageBanner') {
        warnings.push("The AppLayoutTop component only supports a single child component, ".concat(childrenNodes.length, " were provided"));
      }
    } else {
      warnings.push("There is no <MessageBanner> inside of <AppLayoutTop>.");
    }

    if (warnings.length > 0) {
      console.warn(warnings.map(function (warning, index) {
        return "".concat(index + 1, ". ").concat(warning);
      }).join('\n'));
    }
  }, [children]);
  return (0, _core.jsx)(_View.default, (0, _extends2.default)({}, viewProps, {
    width: "100%",
    flexGrow: 1,
    padding: "S100"
  }), children);
};

var AppLayoutTop = (0, _composeStencilComponent.composeStencilComponent)({
  baseComponent: AppLayoutTopBase,
  displayName: 'AppLayoutTop',
  description: 'Top element to wrap a <MessageBanner> which will be displayed on top of the <AppLayoutHeader>',
  propTypes: _objectSpread(_objectSpread({}, (0, _utils.omit)(_View.default.describedPropTypes, ['children'])), {}, {
    children: _stencilReactDesc.PropTypes.node.description('Slot for <MessageBanner> displayed on top')
  })
});
exports.AppLayoutTop = AppLayoutTop;